import { reactive } from 'vue'

// ! global state for package edit  

const state = reactive({
    editBool: false,
    data: null,
})


export default {
    state
}